/* SHORTLIST DETAILS */
export const GET_ALL_SHORTLIST_DETAILS = "GET_ALL_SHORTLIST_DETAILS"
export const GET_ALL_SHORTLIST_DETAILS_SUCCESS = "GET_ALL_SHORTLIST_DETAILS_SUCCESS"
export const GET_ALL_SHORTLIST_DETAILS_FAIL = "GET_ALL_SHORTLIST_DETAILS_FAIL"